import { Box, Image } from "@chakra-ui/react";
import CuLogoHead from "../assets/cu-logo-head.png";
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Cell,
  Text,
  Tooltip,
  Legend,
} from "recharts";
import { useEffect, useState } from "react";
import GCCLogo from "../../../assets/cotton.png";
import GccLogo from "../../../assets/images/resources/cu-logo-tree-foot.png";

// test data
const data = [
  { name: "Parbhani,MH", value: 400 },
  { name: "Amravati,MH", value: 300 },
  { name: "Amreli,GJ", value: 300 },
  { name: "Jalna,MH", value: 200 },
];

const COLORS = [
  "#9CE8B3",
  "#477AD4",
  "#EC806A",
  "#8884d8",
  "#AFAFAF",
  "#477AD4",
  "#13CA4C",
];

const PieChartWithImage = ({ farmerByState }) => {
  const [pieData, setPieData] = useState([]);

  const formatData = (data) => {
    const formattedData = [];
    for (const state in data) {
      let count = 0;
      for (const obj of data[state]) {
        count++;
      }
      formattedData.push({ name: state, value: count });
    }
    setPieData(formattedData);
  };

  useEffect(() => {
    if (farmerByState) {
      formatData(farmerByState);
    }
    return () => {
      setPieData([]);
    };
  }, [farmerByState]);

  return (
    <Box height={"18rem"} width={"100%"} px={"2rem"} position={"relative"}>
      <ResponsiveContainer key={crypto.randomUUID()}>
        <PieChart key={crypto.randomUUID()}>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            stroke="none"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip wrapperStyle={{ zIndex: 999 }} />
        </PieChart>
      </ResponsiveContainer>

      <Image
        height={"5rem"}
        width={"5rem"}
        position={"absolute"}
        top={"50%"}
        left={"50%"}
        transform={"translate(-50%, -50%)"}
        // borderRadius={"100%"}
        src={GccLogo}
        alt={"CU Logo"}
      />
    </Box>
  );
};

export default PieChartWithImage;
